// 课程 type=7|8

import CourseItem from '@pui/CourseItem'
import UIButton from '@components/UI/Button'
import mixin from './mixin'

export default {
  mixins: [mixin],

  methods: {
    onMoreClick () {
      this.onClick({
        title: `${this.title}-更多`,
        redirectType: 0,
        redirectUrl: this.dataSource.moreUrl,
        searchAllWork: true
      })
    }
  },

  render () {
    const {
      dataSource, // from mixin
      list, // from mixin
      style, // from mixin
      title, // from mixin
      onClick, // from mixin
      onMoreClick // from this.methods
    } = this

    return (
      <section class={style.block}>
        <h2 class={style.title}>
          {title}
        </h2>
        <ul class={style.courses}>
          {
            list.map((item, index) => (
              ((index + 1) <= 3 && <li class={style.coursesItem}>
                <CourseItem
                  dataSource={item}
                  dataType='recommend'
                  styleType='1'
                  onClick={() => onClick(item)}
                />
              </li>)
            ))
          }
        </ul>
        {
          dataSource.moreUrl && dataSource.operationVoList.length >= 3 &&
          <div class={style.more}>
            <UIButton
              round
              type='white'
              width={250}
              height={64}
              fontSize={30}
              onClick={onMoreClick}
            >更多课程</UIButton>
          </div>
        }
      </section>
    )
  }
}
